import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import CriarAcaoModal from "./criar/CriarAcaoModal.vue";
import EditarAcaoModal from "./editar/EditarAcaoModal.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { AcaoService } from "../../services/AcaoService";
import { ExercicioService } from "../../services/ExercicioService";
import TextField from "../../components/fields/textField/TextField.vue";
export default {
    name: "GerenciarAcoes",
    components: {
        Breadcrumb,
        CriarAcaoModal,
        EditarAcaoModal,
        StandardPagination,
        ActionButtons,
        TextField
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Ações',
                disabled: true
            }
        ],
        // Controle de responsividade
        isMobile: false,
        isTablet: false,
        windowWidth: 0,
        // Headers base da tabela
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px', priority: 1 },
            { text: 'ID', align: 'center', value: 'id', width: '80px', priority: 1 },
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', width: '100px', priority: 2 },
            { text: 'Cód. Ação', align: 'center', value: 'codigo_acao', width: '120px', priority: 1 },
            { text: 'Descrição da Ação', align: 'center', value: 'descricao_acao', width: '200px', priority: 1 },
            { text: 'Cód. Sub-Ação', align: 'center', value: 'codigo_sub_acao', width: '120px', priority: 3 },
            { text: 'Desc. Sub-Ação', align: 'center', value: 'sub_acao_descricao', width: '180px', priority: 3 },
            { text: 'Cód. Função', align: 'center', value: 'codigo_funcao', width: '120px', priority: 4 },
            { text: 'Desc. Função', align: 'center', value: 'descricao_funcao', width: '180px', priority: 4 },
            { text: 'Cód. Sub-Função', align: 'center', value: 'codigo_sub_funcao', width: '120px', priority: 5 },
            { text: 'Desc. Sub-Função', align: 'center', value: 'descricao_sub_funcao', width: '180px', priority: 5 },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px', priority: 2 },
        ],
        filters: {
            codigoAcaoFilter: "",
            descricaoAcaoFilter: "",
            exercicioFilter: null,
            statusFilter: null
        },
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        showFilters: true,
        page: 1,
        totalItems: 0,
        itemsPerPage: 10
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        // Headers computados - sempre mostra todas as colunas
        computedHeaders() {
            // Sempre retorna todas as colunas, independente da resolução
            // O scroll horizontal cuidará da navegação em telas pequenas
            return this.baseHeaders;
        }
    },
    created() {
        this.listarAcoesPaginado();
        this.listarExerciciosSelect();
        this.handleResize();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarAcoesPaginado();
        },
        'filters.codigoAcaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarAcoesPaginado();
            }
        },
        'filters.descricaoAcaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarAcoesPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarAcoesPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarAcoesPaginado();
            }
        }
    },
    methods: {
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getRowClass() {
            return 'custom-table-row';
        },
        handlePageChanged(newPage) {
            this.page = newPage;
            this.listarAcoesPaginado();
        },
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1; // Volta para a primeira página
            this.listarAcoesPaginado();
        },
        async listarAcoesPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await AcaoService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os ações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os ações:', error);
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Todos",
                        value: null,
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        async destroyAcoes() {
            try {
                const ids = this.itemSelected.map(acao => acao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("acoes[]", id);
                });

                const response = await AcaoService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os ações.');
                }

                this.listarAcoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os ações:', error);
            }
        },
        async activateAcoes() {
            try {
                const ids = this.itemSelected.map(acao => acao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("acoes[]", id);
                });

                const response = await AcaoService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os ações.');
                }

                this.listarAcoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os ações:', error);
            }
        },
        async deactivateAcoes() {
            try {
                const ids = this.itemSelected.map(acao => acao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("acoes[]", id);
                });

                const response = await AcaoService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os ações.');
                }

                this.listarAcoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os ações:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            this.filters.codigoAcaoFilter
            ? filter.append(
                "codigo",
                this.filters.codigoAcaoFilter
            )
            : null;

            this.filters.descricaoAcaoFilter
                ? filter.append(
                    "descricao",
                    this.filters.descricaoAcaoFilter
                )
                : null;

            this.filters.exercicioFilter
                ? filter.append(
                    "exercicio",
                    this.filters.exercicioFilter
                )
                : null;

            this.filters.statusFilter !== null
                ? filter.append(
                    "ativo",
                    this.filters.statusFilter
                )
                : null;

            return filter;
        },
        
        // Métodos para o componente ActionButtons
        navigateToCreate() {
            this.$router.push('/acoes/criar');
        },
        
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/acoes/editar/${this.itemSelected[0].id}`);
            }
        },
        
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        
        // Método para detectar mudanças no tamanho da tela
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768;
            this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
        }
    }
};
